import { useEffect } from 'react';

import { useStableCallback } from '../../../utils/hooks';
import { showNetworkError } from '../../notification/actions';
import { useCodingPropsSelector } from '../context';

export function useDispatchNetworkError(error?: Error) {
    const dispatch = useCodingPropsSelector((p) => p.dispatch);
    const stableDispatch = useStableCallback(dispatch);
    useEffect(() => {
        if (error) {
            stableDispatch?.(showNetworkError(error));
        }
    }, [error, stableDispatch]);
}
